export default {
  "content": "<path d=\"M3.5 19h4v2h-5l-.103-.005A1 1 0 011.5 20v-5h2v4zM22.5 20a1 1 0 01-1 1h-5v-2h4v-4h2v5z\" fill=\"#7B61FF\"/><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M12 11.5c3.094 0 6 2.042 6 5a1 1 0 01-1 1H7a1 1 0 01-1-1c0-2.958 2.906-5 6-5zm0 2c-1.87 0-3.231.913-3.759 2h7.518c-.528-1.087-1.889-2-3.759-2zM12 4.5a3 3 0 110 6 3 3 0 010-6zm0 2a1 1 0 100 2 1 1 0 000-2z\" fill=\"#7B61FF\"/><path d=\"M7.5 5h-4v4h-2V4a1 1 0 011-1h5v2zM21.5 3a1 1 0 011 1v5h-2V5h-4V3h5z\" fill=\"#7B61FF\"/>",
  "attrs": {
    "width": "24",
    "height": "24",
    "viewBox": "0 0 24 24",
    "fill": "none",
    "xmlns": "http://www.w3.org/2000/svg"
  }
};